module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_7.10fc4b84.jpg";